// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cheetah-grid__error-message-element{border-top:1px solid #ff1744;color:#ff1744}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
